import { formatDate } from 'src/libs/moment';
import { UnitsType } from '../constants';
import { EnumItem } from '../types';
import { WarehouseIncomeItemValues } from './services';

export const getEnumDescription = (
  list: EnumItem[] | void,
  id: number
): string => {
  if (!list) return String(id);
  return list.find((item) => item.id === id)?.description ?? String(id);
};

export const formatDocumentDate = (iso: string | null): string => {
  if (!iso) return '';
  return formatDate(iso, 'DD.MM.YYYY HH:mm');
};

export const findNameById = (
  list: { id: string; name: string | null }[] | void,
  id: string | null
): string => {
  if (!id) return '—';
  if (!list) return id;
  return list.find((item) => item.id === id)?.name ?? id;
};

export const getItemTotalPrice = (
  item: Pick<WarehouseIncomeItemValues, 'quantity' | 'purchasePrice'>
): number => (item.quantity ?? 0) * (item.purchasePrice ?? 0);

export const formatPrice = (value: number): string => `${value.toFixed(2)} ₽`;

export const getUnitName = (
  unitsMap: Map<number, string>,
  unitId: number | undefined
): string => {
  if (unitId === undefined || unitId === null) return '';
  if (unitId === UnitsType.NONE) return '';
  return unitsMap.get(unitId) ?? '';
};
